import React, { useState } from 'react';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO, yesNoOpts } from '../../AccountOpening.meta';
import { EditableField } from '../../components/EditableField/EditableField';
import { SpaceProps } from '../../../../theme/styledProps';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';

const fieldName = 'isControlPerson';
const companySymbolsFieldName = 'companySymbols';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const ControlPerson: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();
  const {
    formState: { errors },
  } = formBag;

  const [isEditing, setIsEditing] = useState(!isReview);

  const isControlPerson = formBag.watch('isControlPerson');

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        <Text fontWeight={500}>{get(draftAccount, fieldName) ? 'Yes' : 'No'}</Text>

        {draftAccount.isControlPerson && (
          <Text fontWeight={500}>
            {draftAccount.companySymbols ? draftAccount.companySymbols[0] : null}
          </Text>
        )}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label={
              isReview
                ? undefined
                : 'Are you or a family member a senior executive or 10% shareholder at a publicly traded company?'
            }
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={yesNoOpts}
            aria-label="Are you or a family member a senior executive or 10% shareholder at a publicly traded company?"
          />
        )}
      />

      {isControlPerson && (
        <Box mt="8">
          <Input
            {...formBag.register(companySymbolsFieldName)}
            label={isReview ? undefined : 'Please list the publicly traded companies'}
            type="text"
            placeholder="AAPL, GOOG"
            formVariant={get(errors, companySymbolsFieldName) ? 'error' : undefined}
            helperText={(get(errors, companySymbolsFieldName) as FieldError | undefined)?.message}
            aria-label="Please list the publicly traded companies"
            maxLength={1024}
          />
        </Box>
      )}
    </Box>
  );
};
